import { useState, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { Select } from '../../components/ui';

/**
 * Several Client Dashboard routes (promo codes, add-ons, custom questions) are nested under an
 * event in docs/API.md (`/v1/events/:id/promo-codes` etc.), so the dashboard needs an event
 * chosen before it can list/create those resources. Shared across those three screens.
 */
export function useEventPicker(): { eventId: string | null; picker: ReactNode } {
  const [eventId, setEventId] = useState<string | null>(null);
  const eventsQuery = useQuery({
    queryKey: ['events', 'picker'],
    queryFn: () => api.events.list({ limit: 100 }),
  });

  const picker = (
    <Select value={eventId ?? ''} onChange={(e) => setEventId(e.target.value || null)}>
      <option value="">Select an event...</option>
      {eventsQuery.data?.data.map((e) => (
        <option key={e.id} value={e.id}>
          {e.title}
        </option>
      ))}
    </Select>
  );

  return { eventId, picker };
}
